module.exports = __webpack_public_path__ + "static/media/024_IMG_5568.d4105e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/024_IMG_5568.png
// module id = 590
// module chunks = 0